const DoorToDoor = () => {
  return (
    <div>
  
      <div className="flex flex-col justify-center items-center">
      <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
        
          <div className="flex flex-col justify-center">
            <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
              Door-to-Door
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              TCS has a special focus on intermodal transportation, also known as Door-to-Door transportation. 
              Our rapidly growing road, rail and air network offers national, as well as international customers a 
              flexible, efficient and sustainable way of moving cargo overland.
            </p>
            
              
          </div>
          <div className="flex-1 flex flex-col justify-center lg:mt-[0rem] mt-[1rem]">
              <img src="/overland/Door-to-Door-Insid-File.jpg" alt="" className="w-[100%] rounded-md"/>
          </div>
          </div>
      
      </div>
    </div>
  );
};
  
export default DoorToDoor;
  